import { Injectable } from '@angular/core';
import { FileManagerUtils } from './file-manager-utils';

@Injectable({
  providedIn: 'root'
})
export class FileManagerAPI {

  private fileNameIndices = 'measurement_indices.txt';


  constructor(
    private fileManagerUtils: FileManagerUtils,
  ) {
  }

  readMeasurement = async () => {
    const fileIndices = await this.fileManagerUtils.getFile(this.fileNameIndices);
    const dataIndices = await this.fileManagerUtils.readFile(fileIndices);
    const index = this.fileManagerUtils.getIndex(dataIndices);

    const fileNameMeasurement = `measurement_${index}.txt`;
    const fileMeasurement = await this.fileManagerUtils.getFile(fileNameMeasurement);
    return await this.fileManagerUtils.readFile(fileMeasurement);
  }

  writeMeasurement = async (data: string) => {
    const fileIndices = await this.fileManagerUtils.getFile(this.fileNameIndices);
    const dataIndices = await this.fileManagerUtils.readFile(fileIndices);
    const [index, dataIndicesNew, numMeasurements] = this.fileManagerUtils.appendIndex(dataIndices);
    await this.fileManagerUtils.writeFile(fileIndices, dataIndicesNew, false);

    const fileNameMeasurement = `measurement_${index}.txt`;
    const fileMeasurement = await this.fileManagerUtils.getFile(fileNameMeasurement);
    await this.fileManagerUtils.writeFile(fileMeasurement, data);
    return numMeasurements;
  }

  deleteMeasurement = async () => {
    const fileIndices = await this.fileManagerUtils.getFile(this.fileNameIndices);
    const dataIndices = await this.fileManagerUtils.readFile(fileIndices);
    const index = this.fileManagerUtils.getIndex(dataIndices);
    if (index < 0) {
      console.log(`Could not delete file - none present.`);
      return;
    }
    const [dataIndicesNew, numMeasurements] = this.fileManagerUtils.popIndex(dataIndices);
    await this.fileManagerUtils.writeFile(fileIndices, dataIndicesNew, false);

    const fileNameMeasurement = `measurement_${index}.txt`;
    const fileMeasurement = await this.fileManagerUtils.getFile(fileNameMeasurement);
    await this.fileManagerUtils.deleteFile(fileMeasurement);
    return numMeasurements;
  }

  deleteData = async (fileName: string) => {
    return this.fileManagerUtils.deleteFileGeneric(fileName);
  }

  listData = async () => {
    return this.fileManagerUtils.listFilesGeneric();
  }

  readData = async (fileName: string) => {
    return this.fileManagerUtils.readFileGeneric(fileName);
  }

  writeData = async (data: string, fileName: string) => {
    this.fileManagerUtils.writeFileGeneric(data, fileName);
  }
}
